import Phaser from 'phaser';

export default class Preloader extends Phaser.Scene
{
    constructor()
    {
        super('preload');
        //get API data
    }

    //Preload all textures needed
    preload()
    {
        //Placeholders
        this.load.atlas('cat', 'assets/textures/cat.png','assets/textures/cat.json');
        
        this.load.image('arrowR', 'assets/textures/arrow-right.png');
        this.load.image('arrow', 'assets/textures/arrow-left.png');
        this.load.image('button', 'assets/textures/platform.png');
        this.load.atlas('bg', 'assets/textures/UI/bg.png','assets/textures/UI/bg.json');

        this.load.image('roof', 'assets/textures/roof.png'); 

        this.load.atlas('floor','assets/textures/floor.png','assets/textures/floor.json');
        this.load.atlas('destination', 'assets/textures/destination.png','assets/textures/destination.json');
        this.load.atlas('birds', 'assets/textures/bird.png','assets/textures/bird.json');
        this.load.atlas('balloons', 'assets/textures/balloon.png','assets/textures/balloon.json');

        this.load.image('bird', 'assets/textures/falling-bird.png');
        
        //Loading screen
        this.load.image('LoadingScreen', 'assets/textures/LoadingScreen.png');
        this.load.atlas('bg', 'assets/textures/UI/bg.png','assets/textures/UI/bg.json');
        this.load.atlas('ui', 'assets/textures/UI/ui-ingame.png', 'assets/textures/UI/ui-ingame.json');

        this.load.audio('bgm', 'assets/audio/bgm.mp3');
        this.load.audio('opening', 'assets/audio/opening.mp3');
        this.load.audio('hitSfx', 'assets/audio/bad-move.mp3');
        this.load.audio('pointSfx', 'assets/audio/good-choice.mp3');

        this.loadFont('dongle', 'assets/fonts/Dongle-Bold.ttf');
    }

    init(){
    }

    //Create game scene
    create()
     {
        let self = this;
        this.isMute = false;
        this.add.image(0,0,"LoadingScreen").setOrigin(0);

        this.cameras.main.once('camerafadeincomplete', function (camera) {
            setTimeout(function() {
                camera.fadeOut(500);
            },2000);
        });
                
        this.cameras.main.fadeIn(500);
        setTimeout(function() {   
            self.scene.start('mainmenu');
        },4100);
    }

    loadFont(name, url) {
        let newFont = new FontFace(name, `url(${url})`);
        newFont.load().then(function (loaded) {
            document.fonts.add(loaded);
        }).catch(function (error) {
            console.error("Cannot find font!");
            return error;
        });
    }

}